import assetPath from '/app/xinglets/insights/entry-logged-out/src/components/salary-banner/salary-background-desktop.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')